import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { withApollo, Query } from "react-apollo";

import { registerToken, resetToken } from '../../util';
import { login } from '../../graphql/mutations';
import { clientCredentials } from '../../graphql/queries';
import { ColError, ColLoading } from '../chunk'
import LoginStatus from './LoginStatus'


class Login extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			name: '',
			password: ''
		};

    	this.mutate = this.mutate.bind(this);
    	this.logout = this.logout.bind(this);
    	this.handleLogin = this.handleLogin.bind(this);
	}

	logout() {
		resetToken(this.props.client);
	}

	mutate() {

		if(this.state.name.trim() === '') {
			alert("Pls supply username.")
			return;
		}
		if(this.state.password.trim() === '') {
			alert("Pls supply password.")
			return;
		}

		this.props.client.mutate({
			mutation: login,
			variables: {
				name: this.state.name,
				password: this.state.password
			}
		})
		.then(this.handleLogin)
		.catch(e => {
			alert('Login Error: ' + e);
		});
	}

	handleLogin(response) {
		if(response.data.login) {
			localStorage.setItem('token', response.data.login);
			try {
				registerToken(this.props.client);
				this.props.history.push(`/`);
			} catch(e) {
				console.log(e);
			}
		} else {
			alert('something went wrong ..');
		}
	}
	
	render() {



		return (
			<div className="fullHeight">
				<div className="container">
					<div className="centered login" style={{textAlign: 'center'}}>
						<Query query={clientCredentials}>
						    {({ loading, error, data : {clientCredentials} }) => {

								if( loading ) return (<ColLoading />)
							    if( error ) return (<ColError error={error} />)

								if(clientCredentials.id) {
									return (<div className="richtext">
				      					<div className="avatar avatar--large" style={{backgroundImage: `url(/avatare/${clientCredentials.avatar})`}}></div>
				      					<p>You are logged in as {clientCredentials.name}.</p>

										<div className="button-wrap">
											<button onClick={this.logout} className="button">logout</button>
										</div>
				      				</div>);
				      			} else {

				      				return (
				      					<form onSubmit={(e) => e.preventDefault()}>
											<p style={{textAlign: 'center'}}>
							            		<img src="/logo.svg" className="logo" alt="Dashnet Logo" />
							            	</p>
									  		<input className="input" onChange={e => this.setState({ name: e.target.value })} type="text" placeholder="username" />
									  		<input className="input dist-1" onChange={e => this.setState({ password: e.target.value })} type="password" placeholder="password" />
									    	
											<div className="button-wrap dist-1">
												<NavLink className="button button--secondary" to="/checkin">login ohne passwort</NavLink>
												<button onClick={this.mutate} className="button button--submit">login</button>
											</div>
									    </form>
									);
				      			}
							}}
						</Query>
						<LoginStatus />
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(withApollo(Login))


// WEBPACK FOOTER //
// ./src/components/user/Login.js